import contentSettings from '@site/content.settings'

import { hasCookiebotManager, runWhenCookiebotConsentGranted } from '~/app/cookiebot'

const GTM_CONSENT_CATEGORIES = ['statistics', 'marketing']
const SAIMON_CONSENT_CATEGORIES = ['marketing']

function injectScript({ id, src }) {
  if ((id && document.getElementById(id)) || document.querySelector(`script[src="${src}"]`)) {
    return
  }

  const script = document.createElement('script')
  script.async = true
  script.src = src

  if (id) {
    script.id = id
  }

  document.head.appendChild(script)
}

function loadGoogleTagManager(store) {
  const settings = (store.state.globals && store.state.globals.settings) || {}
  const integrations = settings.integrations || {}
  const gtmId = integrations.google_tag_manager

  if (!gtmId) {
    return
  }

  injectScript({
    id: 'GoogleTagManager',
    src: 'https://www.googletagmanager.com/gtm.js?id=' + encodeURIComponent(gtmId),
  })
}

function loadSaimon(app) {
  if (!app.$env.SAIMON_PROJECT) {
    return
  }

  injectScript({
    id: 'SaimonLoader',
    src: `https://gateway.saimon.ai/${app.$env.SAIMON_PROJECT}/loader.js`,
  })
}

export default function({ app, store }) {
  if (!hasCookiebotManager(contentSettings)) {
    return
  }

  runWhenCookiebotConsentGranted(contentSettings, GTM_CONSENT_CATEGORIES, () => {
    loadGoogleTagManager(store)
  })

  runWhenCookiebotConsentGranted(contentSettings, SAIMON_CONSENT_CATEGORIES, () => {
    loadSaimon(app)
  })
}
